var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"password-rules"},[_c('li',[_vm._v("Длина пароля не менее 12 символов, содержит хотя бы одну заглавную букву, одну цифру и один спец. символ")]),_c('li',[_vm._v("Пароль не должен содержать личную информацию и идентификатор профиля или имя")]),_c('li',[_vm._v("Новый пароль не должен совпадать с предыдущими значениями")])])
}]

export { render, staticRenderFns }